<template>
  <div>
    <div class="display-flex align-center justify-center">
      <div class="margin-r-20">
        <img src="../docTranslation/images/translation/w-img.png" width="36" />
        <p class="font-size-12 color-ccc">Word</p>
      </div>
      <div class="margin-r-20">
        <img
          src="../docTranslation/images/translation/excel-img.png"
          width="36"
        />
        <p class="font-size-12 color-ccc">Excel</p>
      </div>
      <div class="margin-r-20">
        <img
          src="../docTranslation/images/translation/ppt-img.png"
          width="36"
        />
        <p class="font-size-12 color-ccc">PPT</p>
      </div>
      <div class="margin-r-20">
        <img
          src="../docTranslation/images/translation/pdf-img.png"
          width="36"
        />
        <p class="font-size-12 color-ccc">PDF</p>
      </div>
      <div class="margin-r-20">
        <img
          src="../docTranslation/images/translation/txt-img.png"
          width="36"
        />
        <p class="font-size-12 color-ccc">TXT</p>
      </div>
      <div class="margin-r-20">
        <img src="../docTranslation/images/translation/s-img.png" width="36" />
        <p class="font-size-12 color-ccc">SRT</p>
      </div>
      <div class="margin-r-20">
        <img
          src="../docTranslation/images/translation/cad-img.png"
          width="36"
        />
        <p class="font-size-12 color-ccc">CAD</p>
      </div>
      <div class="margin-r-20">
        <img
          src="../docTranslation/images/translation/sdl-img.png"
          width="36"
        />
        <p class="font-size-12 color-ccc">XLIFF</p>
      </div>
      <div class="margin-r-20">
        <img
          src="../docTranslation/images/translation/zip-img.png"
          width="36"
        />
        <p class="font-size-12 color-ccc">ZIP</p>
      </div>
      <div class="margin-r-20">
        <img
          src="../docTranslation/images/translation/fold-img.png"
          width="36"
        />
        <p class="font-size-12 color-ccc">文件夹</p>
      </div>
      <div>
        <a-popover placement="bottomRight">
          <template #content>
            <p class="font-size-13 color-333 weight-600">
              支持
              <span class="!text-[#00b4fa]">20+</span>
              多种格式上传
            </p>
            <p class="font-size-13 color-666 margin-t-8">
              办公文件：doc/docx/docm，xls/xlsx/xlsm，ppt/pptx，rtf
              <br />
              排版文件：pdf，srt
              <br />
              文本文件：txt，csv
              <br />
              CAD文件：dxf，dwg
              <br />
              网页文件：html，htm
              <br />
              本地化文件：json，properties，yaml，yml，xml，dita
              <br />
              双语文件：xliff，sdlxliff，mqxliff
              <br />
              文件包：zip，文件夹
            </p>
            <p class="font-size-13 color-666 margin-t-8">
              使用说明：
              <br />
              1）如pdf有密码保护，请先使用“pdf密码解除”去除加密保护再上传文档。
              <br />
              2）pdf支持可编辑版本翻译，扫描件暂不支持。
            </p>
          </template>
          <img
            src="../docTranslation/images/translation/upload-more-img.png"
            width="36"
          />
          <p class="font-size-12 color-ccc">更多格式</p>
        </a-popover>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
